// src/utils/excerpt.js
//
// AN EXCERPT IS CUT ONCE, ON A WORD, WITH ONE ELLIPSIS (Cowork run 42,
// item 2).
//
// The care-guide index read "…keep a minimu......": the server cut its
// excerpt at a fixed 157 characters, mid-word, and appended "...", and the
// page then appended "..." AGAIN. The server's cut is THE cut now
// (`species_names.excerpt_of`); this is the client's half of the rule:
//
//   * text the server already ended with an ellipsis ("..." or "…") is
//     shown exactly as it arrived — nothing is appended to it;
//   * text that fits is shown as it is, with no ellipsis at all;
//   * text that does not fit is cut on a WORD BOUNDARY, never inside a
//     word, with no stray space or comma before the one ellipsis.

const ENDS_WITH_ELLIPSIS = /(?:\.\.\.|…)\s*$/;
const TAIL = /[\s,;:.…\-–—([{]+$/;

/**
 * @param {string} text
 * @param {number} limit the most characters shown, ellipsis included
 * @returns {string}
 */
export const excerptText = (text, limit = 200) => {
  const said = String(text ?? '').trim();
  if (!said) return '';
  if (ENDS_WITH_ELLIPSIS.test(said) && said.length <= limit + 3) return said;
  if (said.length <= limit) return said;
  const room = Math.max(limit - 3, 1);
  let cut = room;
  if (!/\s/.test(said.charAt(cut))) {
    const space = said.slice(0, cut).search(/\s\S*$/);
    if (space > 0) cut = space;
  }
  const body = said.slice(0, cut).replace(TAIL, '') || said.slice(0, room);
  return `${body}...`;
};

export default excerptText;
